import { AppSettings } from '@macs-gql';

export const appSettings = (
  window as unknown as {
    readonly macsAppSettings: AppSettings;
  }
).macsAppSettings;
